import React from 'react'
import range from 'lodash/range'


export default class Pagination extends React.Component {
    componentDidMount() {
        this.fetchPageNumbers()
    }

    fetchPageNumbers() {
        const { currentPage } = this.props
        const totalPages = this.props.pages.length
        const totalNumbers = 5
        const totalBlocks = 7

        if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - 1)
            const endPage = Math.min(totalPages - 1, currentPage + 1)

            let pages = range(startPage, endPage+1)

            const hasLeftSpill = startPage > 2;
            const hasRightSpill = (totalPages - endPage) > 1
            const spillOffset = totalNumbers - (pages.length + 1)

            switch (true) {
                case (hasLeftSpill && !hasRightSpill): {
                    const extraPages = range(startPage - spillOffset, startPage )
                    pages = ['LEFT_PAGE', ...extraPages, ...pages]
                    break
                }

                case (!hasLeftSpill && hasRightSpill): {
                    const extraPages = range(endPage + 1, endPage + spillOffset + 1)
                    pages = [...pages, ...extraPages, 'RIGHT_PAGE']
                    break
                }

                case (hasLeftSpill && hasRightSpill):
                default: {
                    pages = ['LEFT_PAGE', ...pages, 'RIGHT_PAGE']
                    break
                }
            }
            return [1, ...pages, totalPages]
        }
        else {
            return range(1, totalPages + 1)
        }
    }


    render() {
        const { currentPage, handlePageChange, pages } = this.props
        const thisPages = this.fetchPageNumbers()

        return (
            <div style={{ width:'100%' }}>
                <div className="pager">
                    <div>
                        <p>Page { currentPage } / { pages.length }</p>
                    </div>
                    <div>
                    { thisPages.map( (page, index) => {
                        if (page == 'LEFT_PAGE') {
                            return (
                                <span className="arrow left" key={ index } onClick={ () => handlePageChange(currentPage - 1) }>
                                    <div></div>
                                    <div></div>
                                </span>
                            )
                        }
                        if (page == 'RIGHT_PAGE') {
                            return (
                                <span className="arrow right" key={ index } onClick={ () => handlePageChange(currentPage + 1) }>
                                    <div></div>
                                    <div></div>
                                </span>
                            )
                        }
                        return (
                            <span className={ page == currentPage ? 'active' : '' } onClick={ () => handlePageChange(page) } key={ index }><p>{ page }</p></span>
                        )
                    })}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js